import React, { useEffect } from "react";
import "./WhatWeDo.css";

function WhatWeDo() {
  useEffect(() => {
    const items = document.querySelectorAll(".choose-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="choose-section">
      <h2 className="choose-title">What We Do</h2>
      <p className="choose-sub">
        We provide comprehensive financial services including:
      </p>

      <div className="choose-container">
        {/* LEFT SIDE */}
        <div className="choose-points">
          <div className="choose-item">
            <h3 className="choose-item-title">Investment & Retirement Planning</h3>
            <p className="choose-item-text">
        A secure future begins with smart investments and thoughtful retirement planning. We help you build wealth today while preparing for a comfortable and worry-free tomorrow.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Wealth Creation Strategies</h3>
            <p className="choose-item-text">
Building wealth is not about how much you earn, but how wisely you plan. Our wealth creation strategies are designed to help you grow your money steadily while achieving your long-term financial goals.            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Portfolio Management</h3>
            <p className="choose-item-text">
            Your investments deserve expert care and continuous attention. Our portfolio management services ensure your money is working efficiently to achieve your financial goals.
            </p>
          </div>
        </div>

        {/* CENTER IMAGE */}
        <div className="choose-image">
          <img src="/women.jpg" alt="Financial Advisor" />
        </div>

        {/* RIGHT SIDE */}
        <div className="choose-points">
          <div className="choose-item">
            <h3 className="choose-item-title">Insurance & Risk Planning</h3>
            <p className="choose-item-text">
Life is full of uncertainties, but your financial future doesn’t have to be. Insurance and risk planning ensure that you and your family are protected against unexpected events while maintaining financial stability.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Tax & Estate Planning</h3>
            <p className="choose-item-text">
Effective tax and estate planning ensure that your wealth is preserved, protected, and smoothly passed on to your loved ones. We help you reduce tax burdens while creating a clear financial legacy.
            </p>
          </div>

          <div className="choose-item">
            <h3 className="choose-item-title">Corporate Financial Solutions</h3>
            <p className="choose-item-text">
         Strong financial foundations are the backbone of every successful business. Our corporate financial solutions are designed to support your company’s growth, stability, and long-term success.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
